module.exports = __webpack_public_path__ + "img/logo.0aed58f9.svg";